<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ getTranslation({ es: 'Resultado del pago', en: 'Payment result'}, locale)}}
        </v-card-title>

        <v-card-text>
          <br/>
          <b>ORDER: </b>{{orderID}}<br/><br/>
          {{ orderStatus === 'observation' ?
            getTranslation({ es: 'Error: La transacción ya existe. Contacte con soporte.', en: 'The transaction already exists. Please contact support'}, locale)
            : getTranslation({ es: 'Pago realizado con éxito. En breve recibirá un correo con el resumen de su pedido.', en: 'Payment successfully completed. Shortly you will receive an email with the summary of your order.'}, locale) }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="handleClose"
          >
            {{ $t('common.ok', locale)}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import apiDishOrders from '@/services/apiDishOrders'
import utils from '@/services/utils'
export default {
  props: {
    orderID: {
      type: String,
      default: null,
    },
    orderStatus: {
      type: String,
      default: null
    },
    locale: {
      type: String,
      default: 'es',
    },
  },
  data: () => ({
    dialog: false,
  }),
  watch: {
    orderID () {
      this.init()
    },
    orderStatus () {
      this.init()
    },
  },
  mounted () {
    this.init()
  },
  methods: {
    getTranslation (v, locale) {
      return utils.getTranslation(v, locale)
    },
    init () {
      this.dialog = false
      if (this.orderID && this.orderStatus) this.dialog = true
      if (this.orderID && ['paid', 'observation'].indexOf(this.orderStatus) >= 0) {
        apiDishOrders.setOrderSession('')
        if (this.$store.state.app.dtouchDishOrder) {
          this.$store.state.app.dtouchDishOrder.OrderID = null
        }
      }
    },
    handleClose () {
      this.dialog = false
      this.$router.push('/')
    }
  },
}
</script>
